import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app.css';
import { initPostHog } from './lib/posthog';

initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
